import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/isSameQuarter/index.js';

var require$$52 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$52 as default };
